import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  userData({ data }) {
    return {
      'Account Id': data.account_id,
      'Requester Name': data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
    };
  },
  docsSearchResultsClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Requester Name': data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
      'Item Title': data.docs_title,
    };
  },
  docsSearched({ data }) {
    return {
      'Account Id': data.account_id,
      'Requester Name': data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
      Duration: data.duration,
    };
  },
  contextualHelpitemClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Requester Name': data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
      'Item Title': data.item_title,
      'Item Href': data.item_href,
    };
  },
};

export default Transforms;
